export var environments = {
    API_URL: "https://api.feed-me.app/api",
    FILE_URL: "https://api.feed-me.app/files",
    IS_PROD: true,
    MENU_PUBLIC_URL: "https://www.feed-me.app/menus",
};
